import { render } from "./PhotosView.vue?vue&type=template&id=b9f5a79e"
import script from "./PhotosView.vue?vue&type=script&lang=js"
export * from "./PhotosView.vue?vue&type=script&lang=js"

import "./PhotosView.vue?vue&type=style&index=0&id=b9f5a79e&lang=scss"

import exportComponent from "/home/runner/work/pmanastacio/pmanastacio/apps/anastacio_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__